<template>
    <a-col v-bind="layoutProps" @click.stop="selectWidget(widget)" style="padding: 0;">
        <container-wrapper :widget="widget" class="grid-cell" :class="{ 'grid-cell-design': !!isDesign }"
            :isDesign="isDesign" :widgetList="widgetList" :indexOfParentList="indexOfParentList"
            :style="{ 'min-height': (colHeight > 50 ? colHeight : !!isDesign ? 50 : 0) + 'px' }">
            <template v-if="isDesign">
                <draggable :list="widget.widgetList" item-key="id" tag="transition-group" :component-data="{ name: 'fade' }"
                    v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 300 }" handle=".drag-handler"
                    @end="onDragEnd" @add="onDragAdd" @update="onDragUpdate" :move="checkMove">
                    <template #item="{ element: subwidget, index }">
                        <div class="form-widget-list">
                            <component :is="getWidgetName(subwidget)" :widget="subwidget" :widgetList="widget.widgetList"
                                :indexOfParentList="index" :key="subwidget.id" :isDesign="isDesign" :formData="formData">
                            </component>
                        </div>
                    </template>
                </draggable>
            </template>
            <template v-else>
                <template v-for="(subwidget, index) in widget.widgetList" :key="subwidget.id">
                    <component :is="getWidgetName(subwidget)" :widget="subwidget" :widgetList="widget.widgetList"
                        :indexOfParentList="index" :isDesign="isDesign" :formData="formData">
                    </component>
                </template>
            </template>
        </container-wrapper>
    </a-col>
</template>

<script setup>
import ContainerComponents from "./index.js";
import FieldComponents from "../form-item/index";
import ContainerWrapper from "./container-wrapper.vue";
import { ref, toRefs, computed, inject } from 'vue';

const props = defineProps({
    widget: Object,
    isDesign: Boolean,
    widgetList: Array,
    indexOfParentList: Number,
    colHeight: Number,
    formData: Object,
})
const { widget, isDesign, widgetList, indexOfParentList, colHeight, formData } = toRefs(props)
const layoutProps = computed(() => {
    return {
        // flex: widget.value.options.flex,
        // order: widget.value.options.order || 0,
        span: widget.value.options.span,
        md: widget.value.options.md || widget.value.options.span,
        sm: widget.value.options.sm || widget.value.options.span,
        xs: widget.value.options.xs || widget.value.options.span,
        lg: widget.value.options.lg || widget.value.options.span,
        xl: widget.value.options.xl || widget.value.options.span,
        xxl: widget.value.options.xxl || widget.value.options.span,
        xxxl: widget.value.options.xxl || widget.value.options.span,
        offset: widget.value.options.offset || 0,
        push: widget.value.options.push || 0,
        pull: widget.value.options.pull || 0,
    }
})
const { updateSelectWidget } = inject("designer")

const selectWidget = (widget) => {
    if (!!isDesign.value) {
        updateSelectWidget(widget)
    }
}

const onDragAdd = (evt) => {
    const newIndex = evt.newIndex
    if (!!widget.value.widgetList[newIndex]) {
        updateSelectWidget(widget.value.widgetList[newIndex])
    }
}
const onDragEnd = () => { }
const onDragUpdate = () => { }
const checkMove = (evt) => {
    if (!!evt.draggedContext && !!evt.draggedContext.element) {
        let wgType = evt.draggedContext.element.type + ''
        if (!!evt.to) {
            if (wgType === 'slot') {
                return false
            }
        }
    }

    return true
}
const getWidgetName = (widget) => {
    let obj = { ...FieldComponents, ...ContainerComponents }
    return obj[widget.type + "-widget"]
}
</script>

<style scoped>
.grid-cell {
    padding-right: 5px;
}

.grid-cell-design {
    padding: 5px;
}
</style>
